import QRCode from "react-qr-code";

const QrCodeCard = ({ value, size = 224, title = null }) => {
  console.log('QrCodeCard value', value)
  if (!value) return null;

  return (
    <div className="qr-card">
      {title && <div className="qr-card-title">{title}</div>}
      <div className="qr-card-body" style={{ background: "white", padding: 12, borderRadius: 12 }}>
        <QRCode value={value} size={size} />
      </div>
    </div>
  );
};

export default QrCodeCard;